module.exports = __webpack_public_path__ + "images/icons_v2/volume-high-outlined-c70379a9.svg";